import { animate } from "animejs";
import globalVar from "../utils/globalVar";

class Module13ContentAccordion {
	constructor() {
		const cache = {};

		const initFunc = () => {
			initCache();
			initAccordions();
			registerEvents();
		};

		const initCache = () => {
			cache.accordionItems = document.querySelectorAll(".accordion-item");
		};

		const initAccordions = () => {
			cache.accordionItems.forEach((item) => {
				const content = item.querySelector(".description");
				content.style.height = "0px";
			});
		};

		const registerEvents = () => {
			cache.accordionItems.forEach((item) => {
				const header = item.querySelector(".title-h3");
				header.addEventListener("click", () => toggleAccordion(item));
			});
		};

		const toggleAccordion = (clickedItem) => {
			const content = clickedItem.querySelector(".description");
			const isOpen = clickedItem.classList.contains("active");

			cache.accordionItems.forEach((item) => {
				item.classList.remove("active");
				const itemContent = item.querySelector(".description");
				itemContent.style.height = "0px";
			});

			if (!isOpen) {
				clickedItem.classList.add("active");
				content.style.height = content.scrollHeight + "px";
			}
		};

		initFunc();
	}
}

export { Module13ContentAccordion };
